import Service 			from "./../../Libs/Service";
import { LayoutZoom } 	from "./Layout.Zoom";

let Layout = new Service({

	Name: "Layout",

	Libraries: [LayoutZoom],

	Events: {
		"Current User Loaded": function() {

			if (User.currentUser) {

				//Рабочая среда (какие креативы показывать?)
				this.page = window.localStorage.getItem(`layout-page:${User.currentUser.id}`) || 'playables';
				try {this.pageOptions = JSON.parse(window.localStorage.getItem(`layout-page:${User.currentUser.id}:options`) || '{}') || {}} catch(e) {this.pageOptions = {};}
				this.workspace = window.localStorage.getItem(`layout-workspace:${User.currentUser.id}`) || 'development';

				this.publishersFilter = window.localStorage.getItem(`layout-publishers-filter:${User.currentUser.id}`) || '';
				this.creativesFilter = window.localStorage.getItem(`layout-creatives-filter:${User.currentUser.id}`) || '';
				this.versionsFilter = window.localStorage.getItem(`layout-versions-filter:${User.currentUser.id}`) || '';

				if (this.workspace !== 'development') {
					Broadcast.call('Layout Workspace Changed');
					Creative.autoSelectCreative(true);
				}

				if (this.page === 'banners' && !Metadata.Config['feature-banners']) this.page = 'playables';
				if (this.page === 'end-cards' && !Metadata.Config['feature-end-cards']) this.page = 'playables';
				if (this.page === 'storyboards' && !Metadata.Config['feature-storyboards']) this.page = 'playables';
				if (this.page === 'editable-playables' && !Metadata.Config['feature-editable-playables']) this.page = 'playables';

				if (this.page !== 'playables') {

					Broadcast.call('Layout Page Changed');
					Broadcast.call(`Layout Page Showed:${this.page}`);

				}

				if (this.creativesFilter) Broadcast.call('Creatives Filter Changed', ['from-local-storage']);
				if (this.versionsFilter) Broadcast.call('Versions Filter Changed', ['from-local-storage']);

			}

		},
		"Aside State Changed,Settings Tab Changed,Selected Element Switched,Selected Element Removed": function() {

			this.checkSubAsideToggle();

		},
		"Selected Version Setting Changed": function(settingCodename) {

			if (settingCodename === "creative-template-device") this.setPreviewDeviceFromSettings();
			if (settingCodename === "creative-template-orientation") this.setPreviewOrientationFromSettings();

		},
		"Selected Version Switched": function() {

			if (Creative.SelectedCreative?.type === 'playable') {

				this.setPreviewDeviceFromSettings();
				this.setPreviewOrientationFromSettings();
			}

		}
	},

	Actions: {

	},

	init() {

		this.page = 'playables';
		this.pageOptions = {};
		this.pageHistory = [];

		this.workspace = 'development';

		//Высота хидера
		this.headerHeight = 55;

		//Высота второго хидера
		this.subHeaderHeight = 46;

		//Ширина списка креативов
		this.creativesPlaneWidth = {
			'banners': 60,
			'end-cards': 60,
			'storyboards': 60,
			'editable-playables': 60
		};
		this.creativesPlaneWidthDefault = 60;

		//Ширина списка версий креатива
		this.creativesVersionsPlaneWidth = 250;

		this.previewDevice = 'iPhone';
		this.previewOrientation = {
			iPad: 'portrait',
			iPhone: 'portrait',
			iPhoneX: 'portrait',
			square: 'no'
		};
		this.previewSize = null;

		//Ширина Aside с настройками версии
		this.asideSize = 390;
		//Ширина второго Aside с подробными настройками
		this.subAsideSize = 390;

		//Разделы, в которых показывается панель AI чата
		this.aiChatPages = ['playables', 'storyboards', 'editable-playables', 'banners', 'end-cards'];

		//Высота панели AI чата
		this.aiChatHeight = 250;
		this.aiChatCollapsed = false;
		this.aiChatDefaultHeight = 350; // Высота по умолчанию
		this.aiChatCollapsedHeight = 26; // Если при драге высота становится меньше этого значения - компонент сворачивается до иконки

		//Открыта ли панель настроек
		this.asideOpened = false;
		//Тип панели настроек ('settings', 'testing')
		this.asideType = null;
		//Открыта ли вторая панель настроек
		this.subAsideOpened = false;

		//Вкладка настроек элемента в редакторе
		this.editorElementTab = 'properties'; // 'properties', 'effects', 'events'

		this.publishersFilter = '';
		this.creativesFilter = '';
		this.versionsFilter = '';

		this.settingsTabName = '';

		this.invitationRequested = (location.pathname.indexOf('/invitation/') === 0) ? location.pathname.substr(12) : false;

		// Общий нарастающий zIndex для окон чтобы новое открытое окно было всегда сверху
		this.windowsZIndex = 2000;

	},

	setPage(page, pageOptions = {}) {

		window.localStorage.setItem(`layout-page:${User.currentUser.id}`, page);
		window.localStorage.setItem(`layout-page:${User.currentUser.id}:options`, JSON.stringify(pageOptions));

		let prevPage = this.page;

		this.page = page;
		this.pageOptions = pageOptions;

		this.pageHistory.push({page, pageOptions: _.cloneDeep(pageOptions)});

		Broadcast.call('Layout Page Changed');
		Broadcast.call(`Layout Page Hided:${prevPage}`);
		Broadcast.call(`Layout Page Showed:${this.page}`);

		Server.sendToSocket({
			Navigation: {
				title: 'Page',
				description: page,
				data: pageOptions
			}
		});

	},

	back() {

		let prevHistory = this.pageHistory[this.pageHistory.length - 2];

		if (prevHistory) this.setPage(prevHistory.page, prevHistory.pageOptions);

	},

	toggleAside(type) {

		let prevAsideState = this.asideOpened;

		this.asideOpened = !this.asideOpened;

		if (type && type !== this.asideType) {

			this.asideType = type;

			Broadcast.call('Aside Type Changed');

		}

		if (this.asideOpened) document.body.classList.add('aside-menu-show');
		else document.body.classList.remove('aside-menu-show');

		Broadcast.call('Aside State Changed');

		//Если было открыто а сейчас закрываем
		if (prevAsideState) {

			Broadcast.call('Aside State Closing');
			Broadcast.call('Aside State Closed', [], {delay: 200});

		}
		//Если было закрыто а сейчас открываем
		else {

			Broadcast.call('Aside State Opening');
			Broadcast.call('Aside State Opened', [], {delay: 200});

		}

	},

	checkSubAsideToggle() {

		if (this.asideOpened && this.settingsTabName === 'elements' && Elements.SelectedElement) {

			if (!this.subAsideOpened) {

				this.subAsideOpened = true;

				document.body.classList.add('sub-aside-menu-show');

				Broadcast.call('Sub Aside State Changed');

			}

		}

		else {

			if (this.subAsideOpened) {

				this.subAsideOpened = false;

				document.body.classList.remove('sub-aside-menu-show');

				Broadcast.call('Sub Aside State Changed');

			}

		}

	},

	setLayoutWorkspace(workspace) {

		window.localStorage.setItem(`layout-workspace:${User.currentUser.id}`, workspace);

		this.workspace = workspace;

		Broadcast.call('Layout Workspace Changed');

		Creative.autoSelectCreative(true);

		Server.sendToSocket({
			Navigation: {
				title: 'Workspace',
				description: workspace,
				data: {workspaceCodename: workspace}
			}
		});

	},

	setPublisher(publisherId) {

		Server.sendToSocket({
			ActivePublisher: publisherId,
			Navigation: {
				title: 'Publisher',
				description: Publisher.getPublisher(publisherId)?.title,
				data: {publisherId}
			}
		});

	},

	setCreative(creativeId) {

		Server.sendToSocket({
			ActiveCreative: creativeId,
			ActiveVersion: window.localStorage.getItem(Version.getStoredVersionKey(creativeId)) || null,
			Navigation: {
				title: 'Creative',
				description: Creative.getCreative(creativeId)?.title,
				data: {creativeId}
			}
		});

	},

	setVersion(versionId) {

		let version = Version.getVersion(versionId);

		if (!version) return;

		Server.sendToSocket({
			ActiveVersion: versionId,
			Navigation: {
				title: 'Version',
				description: `${Creative.getCreative(version['creative_id'])?.title} > ${version?.codename || version?.title}`,
				data: {creativeId: version['creative_id'], versionId}
			}
		});

	},

	setPublishersFilter(filter) {

		this.publishersFilter = filter;

		Broadcast.call("Publishers Filter Changed", ['by-user']);

		window.localStorage.setItem(`layout-publishers-filter:${User.currentUser.id}`, filter);

	},

	setCreativesFilter(filter) {

		this.creativesFilter = filter;

		Broadcast.call("Creatives Filter Changed", ['by-user']);

		window.localStorage.setItem(`layout-creatives-filter:${User.currentUser.id}`, filter);

	},

	setVersionsFilter(filter) {

		this.versionsFilter = filter;

		Broadcast.call("Versions Filter Changed", ['by-user']);

		window.localStorage.setItem(`layout-versions-filter:${User.currentUser.id}`, filter);

	},

	isFeatureEnabled(...featureNames) {

		return !_.find(featureNames, featureName => !User.currentUser?.options?.['features']?.[featureName]);

	},

	setPreviewDeviceFromSettings() {

		if (Version.SelectedVersion) this.setPreviewDevice(Settings.getSettingValue("creative-template-device") || "iPhone");
		else this.setPreviewDevice("iPhone");

	},

	setPreviewOrientationFromSettings() {

		if (Version.SelectedVersion) this.setPreviewOrientation(Settings.getSettingValue("creative-template-orientation") || "portrait");
		else this.setPreviewOrientation("portrait");

		Broadcast.call("Preview Orientation Changed", [this.previewOrientation[this.previewDevice]]);

	},

	togglePreviewDevice(device) {

		if (this.previewDevice === device) {

			if (device === 'square') this.setPreviewOrientation('no');
			else this.setPreviewOrientation(this.previewOrientation[this.previewDevice] === 'portrait' ? 'landscape' : 'portrait');

		} else {

			this.setPreviewDevice(device);

		}

	},

	setPreviewDevice(device) {

		this.previewDevice = device;

		Broadcast.call("Preview Device Changed", [this.previewDevice]);

	},

	setPreviewOrientation(orientation) {

		this.previewOrientation[this.previewDevice] = orientation;

		Broadcast.call("Preview Orientation Changed", [this.previewOrientation[this.previewDevice]]);

	},

	setPreviewSize(size) {

		if (this.previewSize?.width === size?.width && this.previewSize?.height === size?.height) return;

		this.previewSize = size;

		Broadcast.call("Preview Size Changed", [this.previewSize]);

	},

	getPreviewSize() {

		let sizes = Version.SelectedVersion?.options?.sizes || [],
			size = this.previewSize;

		if (!_.find(sizes, s => s.width === size?.width && s.height === size?.height) && sizes[0]) {

			this.setPreviewSize(sizes[0]);

			size = sizes[0];

		}

		if (!size) return null;

		return size;

	},

	getPreviewSizeKey(size = null) {

		if (!size) size = this.getPreviewSize();
		if (!size) return "default";

		return `${size.width}x${size.height}`;

	},

	// Ориентация текущего размера превью (portrait / landscape). Для размеров из метаданных берём
	// явно указанную ориентацию, иначе определяем по соотношению сторон
	getPreviewSizeOrientation(size = null) {

		if (!size) size = this.getPreviewSize();
		if (!size) return 'portrait';

		if (size.orientation) return size.orientation;

		let creativeType = Creative.SelectedCreative?.type;
		let metadataSize = _.find(Metadata.Sizes, o => o.type === creativeType && o.width === size.width && o.height === size.height);

		if (metadataSize?.options?.orientation) return metadataSize.options.orientation;

		return size.width > size.height ? 'landscape' : 'portrait';

	},

	setSettingsTab(tabName) {

		let prevTabName = this.settingsTabName;

		this.settingsTabName = tabName;

		Broadcast.call("Settings Tab Changed", [tabName, prevTabName]);
		Broadcast.call(`Settings Tab Changed:${tabName}`, [prevTabName]);

		Server.sendToSocket({
			Navigation: {
				title: 'Settings Tab',
				description: _.capitalize(tabName),
				data: {tabName}
			}
		});

	},

	setEditorElementTab(tabName) {

		this.editorElementTab = tabName;

		Broadcast.call("Element Tab Changed", [tabName]);
		Broadcast.call(`Element Tab Changed:${tabName}`);

		Server.sendToSocket({
			Navigation: {
				title: 'Element Tab',
				description: _.capitalize(tabName),
				data: {tabName}
			}
		});

	},

	copyTextToClipboard(text) {

		let textArea = document.createElement("textarea");

		//
		// *** This styling is an extra step which is likely not required. ***
		//
		// Why is it here? To ensure:
		// 1. the element is able to have focus and selection.
		// 2. if element was to flash render it has minimal visual impact.
		// 3. less flakyness with selection and copying which **might** occur if
		//    the textarea element is not visible.
		//
		// The likelihood is the element won't even render, not even a
		// flash, so some of these are just precautions. However in
		// Internet Explorer the element is visible whilst the popup
		// box asking the user for permission for the web page to
		// copy to the clipboard.
		//

		// Place in top-left corner of screen regardless of scroll position.
		textArea.style.position = 'fixed';
		textArea.style.top = 0;
		textArea.style.left = 0;

		// Ensure it has a small width and height. Setting to 1px / 1em
		// doesn't work as this gives a negative w/h on some browsers.
		textArea.style.width = '2em';
		textArea.style.height = '2em';

		// We don't need padding, reducing the size if it does flash render.
		textArea.style.padding = 0;

		// Clean up any borders.
		textArea.style.border = 'none';
		textArea.style.outline = 'none';
		textArea.style.boxShadow = 'none';

		// Avoid flash of white box if rendered for any reason.
		textArea.style.background = 'transparent';

		textArea.value = text;

		document.body.appendChild(textArea);
		textArea.focus();
		textArea.select();

		try {
			var successful = document.execCommand('copy');
			var msg = successful ? 'successful' : 'unsuccessful';
			console.log('Copying text command was ' + msg);
		} catch (err) {
			console.log('Oops, unable to copy');
		}

		document.body.removeChild(textArea);

	},

	getCreativesPlaneWidth() {

		return (Layout.creativesPlaneWidth[Layout.page] || Layout.creativesPlaneWidthDefault);

	},

	setAIAgentHeight(height, collapsed = false) {

		let prevHeight = this.aiChatHeight;
		let prevCollapsed = this.aiChatCollapsed;

		this.aiChatHeight = height;
		this.aiChatCollapsed = collapsed;

		if (prevHeight !== height || prevCollapsed !== collapsed) {

			Broadcast.call("AI Chat Height Changed", [this.aiChatHeight, this.aiChatCollapsed]);

		}

	},

	getAIAgentHeight() {

		if (!_.includes(this.aiChatPages, this.page)) return 0;
		// Без выбранной версии (нет креативов нужного типа или версий в креативе) чат не отображается
		if (!Version.SelectedVersion) return 0;
		if (this.aiChatCollapsed) return 0;

		return this.aiChatHeight || 0;

	}

});

window.Layout = Layout;

export { Layout }

